namespace GeniuzPOS.Customer {
    export interface CsCustomerRow {
        Id?: number;
        CustCode?: string;
        CustGroupCode?: string;
        CustGroupName?: string;
        CustName?: string;
        ContactName?: string;
        Address?: string;
        Tumbol?: string;
        Amphur?: string;
        Province?: string;
        ZipCode?: string;
        Country?: string;
        CusTel?: string;
        Email?: string;
        CusRemark?: string;
        CustRegName?: string;
        CustRegAddress?: string;
        CustRegTumbol?: string;
        CustRegAmphur?: string;
        CustRegProvince?: string;
        CustRegZipCode?: string;
        CustTaxId?: string;
        CustRegCountry?: string;
        CustRegAdd1?: string;
        CustRegAdd2?: string;
        CustRegAdd3?: string;
        ShipName?: string;
        ShipAddress?: string;
        ShipTumbol?: string;
        ShipAmphur?: string;
        ShipProvince?: string;
        ShipZipCode?: string;
        ShipCountry?: string;
        ShipAddLine1?: string;
        ShipAddLine2?: string;
        ShipAddLine3?: string;
        SalesmanId?: string;
        SalesmanName?: string;
        SaleMemo?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace CsCustomerRow {
        export const idProperty = 'CustCode';
        export const nameProperty = 'CustName';
        export const localTextPrefix = 'Customer.CsCustomer';
        export const lookupKey = 'Customer.CsCustomer';

        export function getLookup(): Q.Lookup<CsCustomerRow> {
            return Q.getLookup<CsCustomerRow>('Customer.CsCustomer');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ลูกค้า:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ลูกค้า:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ลูกค้า:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ลูกค้า:Modify';

        export declare const enum Fields {
            Id = "Id",
            CustCode = "CustCode",
            CustGroupCode = "CustGroupCode",
            CustGroupName = "CustGroupName",
            CustName = "CustName",
            ContactName = "ContactName",
            Address = "Address",
            Tumbol = "Tumbol",
            Amphur = "Amphur",
            Province = "Province",
            ZipCode = "ZipCode",
            Country = "Country",
            CusTel = "CusTel",
            Email = "Email",
            CusRemark = "CusRemark",
            CustRegName = "CustRegName",
            CustRegAddress = "CustRegAddress",
            CustRegTumbol = "CustRegTumbol",
            CustRegAmphur = "CustRegAmphur",
            CustRegProvince = "CustRegProvince",
            CustRegZipCode = "CustRegZipCode",
            CustTaxId = "CustTaxId",
            CustRegCountry = "CustRegCountry",
            CustRegAdd1 = "CustRegAdd1",
            CustRegAdd2 = "CustRegAdd2",
            CustRegAdd3 = "CustRegAdd3",
            ShipName = "ShipName",
            ShipAddress = "ShipAddress",
            ShipTumbol = "ShipTumbol",
            ShipAmphur = "ShipAmphur",
            ShipProvince = "ShipProvince",
            ShipZipCode = "ShipZipCode",
            ShipCountry = "ShipCountry",
            ShipAddLine1 = "ShipAddLine1",
            ShipAddLine2 = "ShipAddLine2",
            ShipAddLine3 = "ShipAddLine3",
            SalesmanId = "SalesmanId",
            SalesmanName = "SalesmanName",
            SaleMemo = "SaleMemo",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
